import { Component, OnInit } from '@angular/core';
import { UserAddressService } from 'src/app/services/user-address/user-address.service';
import { Router } from '@angular/router';
import { AlertComponent } from 'src/app/shared/alert/alert.component';
import { NavController } from '@ionic/angular';
import { AreaService } from 'src/app/services/Area/area.service';

@Component({
  selector: 'app-address-multiple',
  templateUrl: './address-multiple.page.html',
  styleUrls: ['./address-multiple.page.scss'],
})
export class AddressMultiplePage implements OnInit {
userdata:any;
allAddress:any;
selectedAddress:any;
city:any;
currentLocation:any;

  constructor(
    private userAddressService:UserAddressService,
    private r:Router,
    private alert:AlertComponent,
    private navCtrl:NavController,
    private areaServic:AreaService
    
    ) { 

  }


  goback(){
    this.navCtrl.navigateBack('/select-datetime');
  }
  
  ionViewDidEnter(){
    this.areaServic.getAreasDetails(localStorage.getItem('locationId')).then((res)=>{
      console.log(res);
      this.currentLocation = res;
    })
    this.areaServic.showHome=false

    let data = JSON.parse(localStorage.getItem('JobData'));
    this.userdata = JSON.parse(localStorage.getItem('userProfile'));
    this.city = localStorage.getItem('location');
    // this.city.toString();
    console.log(this.city,"city")

    this.userAddressService.getAllUserAddresss(this.userdata.id).then((res:any)=>{
      console.log(res);
      this.allAddress = res;
      this.allAddress.map((element)=>{
        if((element.city).trim()==this.city.trim()){
element.status=true;
console.log(element)
        }else{
          element.status=false;
console.log(element)

        }
        if(data.address && data.address.id == element.id){
          this.selectedAddress = element
        }
      })
    })
  }

  editLocation(address,event){
event.stopPropagation()

    this.r.navigate(['/select-location'],
    {
      queryParams:{"value":JSON.stringify(address)}
    })
  }

  selectLocation(){

    this.r.navigate(['/select-location']);
  }

  deleteAddress(address,i,event){
event.stopPropagation()
    this.alert.presentAlertConfirm("Are You sure You Want to Delete?").then((res)=>{
			console.log(address);
			if(res['role'] == 'cancel' ){
				console.log("cancel");
			}else{
        this.userAddressService.deleteUserAddress(address.id).then((res)=>{
          console.log(res);
          this.allAddress.splice(i,1);
        })
        }
      });
    
    }


    nextPage(){
      console.log(this.selectedAddress);
      if(this.selectedAddress){
        let data = JSON.parse(localStorage.getItem('JobData'));
        console.log(data);
        data.address = this.selectedAddress;
        data.addressId = this.selectedAddress.id;
        data.userId= this.userdata.id;
        data.user = this.userdata;
        localStorage.setItem('JobData',JSON.stringify(data));
        this.navCtrl.navigateForward('/cart-detail');
  
      }else{
        this.alert.presentAlert("Information","Select Address to Continue!");
      }
    
    }

  ngOnInit() {
  }

  arePointsNear(checkPoint, centerPoint, km) {
    var ky = 40000 / 360;
    var kx = Math.cos(Math.PI * centerPoint.lat / 180.0) * ky;
    var dx = Math.abs(centerPoint.lng - checkPoint.lng) * kx;
    var dy = Math.abs(centerPoint.lat - checkPoint.lat) * ky;
    return Math.sqrt(dx * dx + dy * dy) <= km;
  }
}
